// extracted by mini-css-extract-plugin
export var blue = "tag-module--blue--5SbGL";
export var cyan = "tag-module--cyan--4CvVv";
export var geekblue = "tag-module--geekblue--fHh9o";
export var gold = "tag-module--gold--1zYer";
export var green = "tag-module--green--jtnxH";
export var lime = "tag-module--lime--7VmTz";
export var magenta = "tag-module--magenta--r4LoM";
export var orange = "tag-module--orange--FeHPd";
export var purple = "tag-module--purple--oKVtp";
export var red = "tag-module--red--ZILa2";
export var rsAvatarBlue = "tag-module--rs-avatar-blue--WydE4";
export var rsAvatarCyan = "tag-module--rs-avatar-cyan--keD2x";
export var rsAvatarGreen = "tag-module--rs-avatar-green--3mlcr";
export var rsAvatarOrange = "tag-module--rs-avatar-orange--WEtVD";
export var rsAvatarRed = "tag-module--rs-avatar-red--+j49t";
export var rsAvatarViolet = "tag-module--rs-avatar-violet--2q9XM";
export var rsAvatarYellow = "tag-module--rs-avatar-yellow--HYiA7";
export var rsBadgeBlue = "tag-module--rs-badge-blue--oevRN";
export var rsBadgeContent = "tag-module--rs-badge-content--Qjvq-";
export var rsBadgeCyan = "tag-module--rs-badge-cyan--HX96C";
export var rsBadgeGreen = "tag-module--rs-badge-green--25g70";
export var rsBadgeIndependent = "tag-module--rs-badge-independent--5f+4l";
export var rsBadgeOrange = "tag-module--rs-badge-orange--9xc7r";
export var rsBadgeRed = "tag-module--rs-badge-red--EX4tN";
export var rsBadgeViolet = "tag-module--rs-badge-violet--wpV1D";
export var rsBadgeYellow = "tag-module--rs-badge-yellow--w9uNM";
export var rsBtnBlue = "tag-module--rs-btn-blue--Cn-qC";
export var rsBtnCyan = "tag-module--rs-btn-cyan--tfujq";
export var rsBtnGreen = "tag-module--rs-btn-green--SYUlJ";
export var rsBtnOrange = "tag-module--rs-btn-orange--gfQPD";
export var rsBtnRed = "tag-module--rs-btn-red--i37D6";
export var rsBtnViolet = "tag-module--rs-btn-violet--sb7zD";
export var rsBtnYellow = "tag-module--rs-btn-yellow--wlNSY";
export var rsCheckboxBlue = "tag-module--rs-checkbox-blue--hMDy9";
export var rsCheckboxChecked = "tag-module--rs-checkbox-checked--CKOV5";
export var rsCheckboxControl = "tag-module--rs-checkbox-control--SYwX3";
export var rsCheckboxCyan = "tag-module--rs-checkbox-cyan--D2t5w";
export var rsCheckboxGreen = "tag-module--rs-checkbox-green--cpbhx";
export var rsCheckboxIndeterminate = "tag-module--rs-checkbox-indeterminate--DWPfQ";
export var rsCheckboxInner = "tag-module--rs-checkbox-inner--zLBl5";
export var rsCheckboxOrange = "tag-module--rs-checkbox-orange--2QSLo";
export var rsCheckboxRed = "tag-module--rs-checkbox-red--w63jM";
export var rsCheckboxViolet = "tag-module--rs-checkbox-violet--7E8rP";
export var rsCheckboxYellow = "tag-module--rs-checkbox-yellow--6DaxY";
export var rsFlexBoxGridItem1 = "tag-module--rs-flex-box-grid-item-1--pNIkG";
export var rsFlexBoxGridItem10 = "tag-module--rs-flex-box-grid-item-10--SPk5M";
export var rsFlexBoxGridItem11 = "tag-module--rs-flex-box-grid-item-11--w1yCK";
export var rsFlexBoxGridItem12 = "tag-module--rs-flex-box-grid-item-12--4E5RG";
export var rsFlexBoxGridItem13 = "tag-module--rs-flex-box-grid-item-13--qdSF+";
export var rsFlexBoxGridItem14 = "tag-module--rs-flex-box-grid-item-14--nabY4";
export var rsFlexBoxGridItem15 = "tag-module--rs-flex-box-grid-item-15--O2hdP";
export var rsFlexBoxGridItem16 = "tag-module--rs-flex-box-grid-item-16--c-Nnw";
export var rsFlexBoxGridItem17 = "tag-module--rs-flex-box-grid-item-17--ULH9D";
export var rsFlexBoxGridItem18 = "tag-module--rs-flex-box-grid-item-18--XJkuJ";
export var rsFlexBoxGridItem19 = "tag-module--rs-flex-box-grid-item-19--W619w";
export var rsFlexBoxGridItem2 = "tag-module--rs-flex-box-grid-item-2--3a7sO";
export var rsFlexBoxGridItem20 = "tag-module--rs-flex-box-grid-item-20--yeCE4";
export var rsFlexBoxGridItem21 = "tag-module--rs-flex-box-grid-item-21--0ilNX";
export var rsFlexBoxGridItem22 = "tag-module--rs-flex-box-grid-item-22--vwCD9";
export var rsFlexBoxGridItem23 = "tag-module--rs-flex-box-grid-item-23--xWSLn";
export var rsFlexBoxGridItem24 = "tag-module--rs-flex-box-grid-item-24--O1+vz";
export var rsFlexBoxGridItem3 = "tag-module--rs-flex-box-grid-item-3--sG8wh";
export var rsFlexBoxGridItem4 = "tag-module--rs-flex-box-grid-item-4--51XSl";
export var rsFlexBoxGridItem5 = "tag-module--rs-flex-box-grid-item-5--VRuqu";
export var rsFlexBoxGridItem6 = "tag-module--rs-flex-box-grid-item-6--F13Qw";
export var rsFlexBoxGridItem7 = "tag-module--rs-flex-box-grid-item-7--3plxU";
export var rsFlexBoxGridItem8 = "tag-module--rs-flex-box-grid-item-8--dMnbM";
export var rsFlexBoxGridItem9 = "tag-module--rs-flex-box-grid-item-9--ChpiU";
export var rsFlexBoxGridItemOrder1 = "tag-module--rs-flex-box-grid-item-order-1--1WIyF";
export var rsFlexBoxGridItemOrder10 = "tag-module--rs-flex-box-grid-item-order-10--f0fro";
export var rsFlexBoxGridItemOrder11 = "tag-module--rs-flex-box-grid-item-order-11--l9ybw";
export var rsFlexBoxGridItemOrder12 = "tag-module--rs-flex-box-grid-item-order-12--oE8kN";
export var rsFlexBoxGridItemOrder13 = "tag-module--rs-flex-box-grid-item-order-13--sV2m-";
export var rsFlexBoxGridItemOrder14 = "tag-module--rs-flex-box-grid-item-order-14--xYALG";
export var rsFlexBoxGridItemOrder15 = "tag-module--rs-flex-box-grid-item-order-15--MOfyk";
export var rsFlexBoxGridItemOrder16 = "tag-module--rs-flex-box-grid-item-order-16--QXurx";
export var rsFlexBoxGridItemOrder17 = "tag-module--rs-flex-box-grid-item-order-17--l8eif";
export var rsFlexBoxGridItemOrder18 = "tag-module--rs-flex-box-grid-item-order-18--ZRDRu";
export var rsFlexBoxGridItemOrder19 = "tag-module--rs-flex-box-grid-item-order-19--2tpMz";
export var rsFlexBoxGridItemOrder2 = "tag-module--rs-flex-box-grid-item-order-2--da4OV";
export var rsFlexBoxGridItemOrder20 = "tag-module--rs-flex-box-grid-item-order-20--FU5u7";
export var rsFlexBoxGridItemOrder21 = "tag-module--rs-flex-box-grid-item-order-21--UFoRc";
export var rsFlexBoxGridItemOrder22 = "tag-module--rs-flex-box-grid-item-order-22--ynq2o";
export var rsFlexBoxGridItemOrder23 = "tag-module--rs-flex-box-grid-item-order-23--CG9xy";
export var rsFlexBoxGridItemOrder24 = "tag-module--rs-flex-box-grid-item-order-24--lvCU3";
export var rsFlexBoxGridItemOrder3 = "tag-module--rs-flex-box-grid-item-order-3--jNqlB";
export var rsFlexBoxGridItemOrder4 = "tag-module--rs-flex-box-grid-item-order-4--BSJXE";
export var rsFlexBoxGridItemOrder5 = "tag-module--rs-flex-box-grid-item-order-5--NTPmp";
export var rsFlexBoxGridItemOrder6 = "tag-module--rs-flex-box-grid-item-order-6--G9qcs";
export var rsFlexBoxGridItemOrder7 = "tag-module--rs-flex-box-grid-item-order-7--g3AGT";
export var rsFlexBoxGridItemOrder8 = "tag-module--rs-flex-box-grid-item-order-8--kYumj";
export var rsFlexBoxGridItemOrder9 = "tag-module--rs-flex-box-grid-item-order-9--lwimV";
export var rsRadioBlue = "tag-module--rs-radio-blue--sUIiD";
export var rsRadioChecked = "tag-module--rs-radio-checked--ET+hB";
export var rsRadioControl = "tag-module--rs-radio-control--2xR6j";
export var rsRadioCyan = "tag-module--rs-radio-cyan--ulxvb";
export var rsRadioGreen = "tag-module--rs-radio-green--KgIPN";
export var rsRadioInner = "tag-module--rs-radio-inner--me-r-";
export var rsRadioOrange = "tag-module--rs-radio-orange--53MTE";
export var rsRadioRed = "tag-module--rs-radio-red--RtDL1";
export var rsRadioViolet = "tag-module--rs-radio-violet--Iwb46";
export var rsRadioYellow = "tag-module--rs-radio-yellow--DffaJ";
export var rsTagBlue = "tag-module--rs-tag-blue--EgvR+";
export var rsTagCyan = "tag-module--rs-tag-cyan--bTjyj";
export var rsTagGreen = "tag-module--rs-tag-green--sbPf8";
export var rsTagOrange = "tag-module--rs-tag-orange--fp8PJ";
export var rsTagRed = "tag-module--rs-tag-red--5M7II";
export var rsTagViolet = "tag-module--rs-tag-violet--oddNe";
export var rsTagYellow = "tag-module--rs-tag-yellow--FPtIJ";
export var rsTextBlue = "tag-module--rs-text-blue--mS4x4";
export var rsTextCyan = "tag-module--rs-text-cyan--pKQ5X";
export var rsTextGreen = "tag-module--rs-text-green--hAoBI";
export var rsTextOrange = "tag-module--rs-text-orange--Acb9z";
export var rsTextRed = "tag-module--rs-text-red--oLjh7";
export var rsTextViolet = "tag-module--rs-text-violet--Yq5iF";
export var rsTextYellow = "tag-module--rs-text-yellow--BCaeZ";
export var rsThemeDark = "tag-module--rs-theme-dark--UIxhH";
export var rsThemeHighContrast = "tag-module--rs-theme-high-contrast--vBeKN";
export var rsToggleBlue = "tag-module--rs-toggle-blue--WPP5l";
export var rsToggleChecked = "tag-module--rs-toggle-checked--Yv8-6";
export var rsToggleCyan = "tag-module--rs-toggle-cyan---v5+E";
export var rsToggleGreen = "tag-module--rs-toggle-green--AgTB4";
export var rsToggleOrange = "tag-module--rs-toggle-orange--mPUPx";
export var rsTogglePresentation = "tag-module--rs-toggle-presentation--egLFY";
export var rsToggleRed = "tag-module--rs-toggle-red--7YXGm";
export var rsToggleViolet = "tag-module--rs-toggle-violet--Y0FxM";
export var rsToggleYellow = "tag-module--rs-toggle-yellow--Kd9em";
export var tag = "tag-module--tag--g9N3Z";
export var volcano = "tag-module--volcano--elMFW";